export default __webpack_public_path__ + "static/facial_sweet-beefa5f67d19f3db57fd758f50c79fff.jpg";